<template>
    <div class="w-100 row g-0 mb-2">
        <div v-if="isFacility" class="col-12 col-lg-4 pe-lg-2 form-group d-flex flex-column">
            <label for="facility-name"> Facility Name </label>
            <TypeaheadInput
                id="facility-name"
                :getData="getVendorList"
                :value="selectedFacility"
                v-on:valueChanged="updateFacility"
                :init-value="selectedFacility"
                placeholder="Start Typing..."
            ></TypeaheadInput>
            <button class="btn btn-primary mt-2 w-40" @click="handleDirectionToFacility()">Add Facility</button>
        </div>
        <div class="col-12 col-lg-4 pe-lg-2 form-group">
            <label>
                Country
                <span class="text-danger">*</span>
            </label>
            <CountryTypeahead
                :updateSelectedCountry="updateSelectedCountry"
                :prefill-country="address.country"
                :disabled="selectedFacility ? true : false"
                v-on:blurredInput="v$.address.country.$touch()"
            >
            </CountryTypeahead>
            <span v-if="v$.address.country.$error" class="field-invalid">Country is required.</span>
        </div>
        <div class="w-100"></div>
        <div class="col-12 col-lg-4 pe-lg-2 form-group">
            <label>
                Address Line 1
                <span class="text-danger" v-if="isRequired">*</span>
            </label>
            <PlacesAutocomplete
                v-model:street="address.addressLine1"
                v-model:city="address.city"
                v-model:state="address.state"
                v-model:zip="address.zipCode"
                v-model:county="address.county"
                v-model:latitude="address.latitude"
                v-model:longitude="address.longitude"
                v-model:country="autoCompleteCountry"
                :places-changed-call-back="placesChangedCallBack"
                v-on:blurredInput="v$.address.addressLine1.$touch()"
            >
            </PlacesAutocomplete>
            <span v-if="v$.address.addressLine1.$error" class="field-invalid">Address Line 1 is required.</span>
        </div>
        <div class="col-12 col-lg-4 pe-lg-2 form-group">
            <label for="referral-address-line-2"> Address Line 2 </label>
            <input
                id="referral-address-line-2"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Address Line 2"
                v-model="address.addressLine2"
            />
        </div>
        <div class="w-100"></div>
        <div class="col-12 col-lg-2 pe-lg-2 form-group">
            <label for="referral-city">
                City
                <span class="text-danger" v-if="isRequired">*</span>
            </label>
            <input
                id="referral-city"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter City"
                v-model="address.city"
                :disabled="selectedFacility ? true : false"
                @blur="v$.address.city.$touch()"
            />
            <span v-if="v$.address.city.$error" class="field-invalid">City is required.</span>
        </div>
        <div class="col-12 col-lg-2 pe-lg-2 form-group">
            <label>
                {{ isUnitedStates ? "State" : "State / Province / Territory" }}
                <span class="text-danger" v-if="isRequired">*</span>
            </label>
            <StateTypeahead
                v-model:selected-state="selectedState"
                v-model:prefill-state="address.state"
                :disabled="selectedFacility ? true : false"
                v-if="isUnitedStates"
                v-on:blurredInput="v$.address.state.$touch()"
            >
            </StateTypeahead>
            <input
                class="form-control"
                maxlength="50"
                type="text"
                v-model="address.state"
                placeholder="Enter State / Province / Territory"
                :disabled="selectedFacility ? true : false"
                @blur="v$.address.state.$touch()"
                v-else
            />
            <span v-if="v$.address.state.$error" class="field-invalid">State is required.</span>
        </div>
        <div class="col-12 col-lg-2 pe-lg-2 form-group">
            <label for="referral-zip">
                <span class="badge me-1" v-if="showCode">A0550</span> {{ isUnitedStates ? "ZIP" : "Postal Code" }}
                <span class="text-danger" v-if="isRequired">*</span>
            </label>
            <input
                id="referral-zip"
                class="form-control"
                maxlength="10"
                type="text"
                v-number-only
                :value="formatZipCode(address.zipCode)"
                @change="(e) => handleZipcodeChange(e)"
                placeholder="Enter Zip"
                :disabled="selectedFacility ? true : false"
                v-if="isUnitedStates"
                @blur="v$.address.zipCode.$touch()"
            />
            <input
                id="referral-zip"
                class="form-control"
                maxlength="50"
                type="text"
                v-model="address.zipCode"
                placeholder="Enter Postal Code"
                :disabled="selectedFacility ? true : false"
                @blur="v$.address.zipCode.$touch()"
                v-else
            />
            <span v-if="v$.address.zipCode.$error" class="field-invalid">Zip code is required.</span>
        </div>
        <div class="col-12 col-lg-2 pe-lg-2 form-group">
            <label for="referral-county"> County <span class="text-danger" v-if="isRequired">*</span></label>
            <input
                id="referral-county"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter County"
                v-model="address.county"
            />
        </div>
    </div>
</template>

<script src="./AddressForm.ts"></script>
